<template>
  <FKBreadCrumb :page="$t('page.patients')" />
  <PatientsList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import PatientsList from "@/components/FK/Patient/PatientsList.vue";

export default defineComponent({
  name: "PatientsListPage",
  components: {
    FKBreadCrumb,
    PatientsList,
  },
});
</script>